module.exports = __webpack_public_path__ + "static/media/client27.7d7312f8.webp";